<template>
  <div class="hrms-orgchart">
    <div id="chart-container">
      <div class="orgchart">
        <orgchart-node :data="data"
                       :rootNode="true"
                       :labels="labels"
                       :receivedOrgBodyDetail="receivedOrgBodyDetail" />
      </div>
    </div>
  </div>
</template>

<script>
import orgchartNode from 'components/orgchart/orgchartNode'
require('assets/css/orgchart.min.css')

export default {
  name: 'orgchart',
  props: {
    data: {
      type: Object,
      required: true
    },
    labels: {
      type: Object
    },
    receivedOrgBodyDetail: {
      type: Function
    }
  },
  components: {
    orgchartNode
  }
}
</script>

<style lang="scss">
.hrms-orgchart {
  #chart-container {
    /* background: #FFF; */
    /* box-shadow: 0px 1px 2px rgba(0,0,0,0.3); */
    text-align: center;
  }

  .content {
    min-height: 20px !important;
  }

  .orgchart {
     background: #ecf0f5;
    /* .second-menu-icon {
       transition: opacity .5s;
      opacity: 0;
      right: -5px;
      top: -5px;
      z-index: 2;
      color: rgba(68, 157, 68, 0.5);
      font-size: 18px;
      position: absolute;
      &:hover {
        color: #449d44;
      }
    } */
    .node {
      background: #FFF;
      width: 200px;
      border-top: 1px solid #BDBDBD;
      border-left: 1px solid #BDBDBD;
      border-right: 1px solid #BDBDBD;
      border-bottom: 1px solid #BDBDBD;
      box-shadow: 0 1px 1px rgba(0,0,0,0.2);
      margin: 5px;
      border-radius: 3px;
      padding: 20px 0;
      /* .second-menu {
        position: absolute;
        top: 0;
        right: -70px;
        border-radius: 35px;
        box-shadow: 0 0 10px 1px #999;
        background-color: #fff;
        z-index: 1;
      } */
      .avatar {
        width: 80px;
        height: 80px;
        border-radius: 40px;
        border: 1px solid #BDBDBD;
        margin: 0 0 10px;
      }
      >.name {
        font-size: 18px;
        font-family: 'cloudbold';
        color: #212121;
      }
      >.company {
        font-weight: 700;
        padding: 5px 0 0;
        font-size: 14px;
        color: #424242;
      }
      >.position {
        font-weight: 700;
        font-size: 14px;
        color: #424242;
      }

      .third-menu {
        position: absolute;
        display: inline-flex;
        margin-top: -20px;
        margin-left: 20px;
      }
      .secretary {
        display: inline-block;
        width: 50px;
        height: 50px;
        border-radius: 30px;
        margin: 5px;
      }
      .hidden {
        display: none!important;
      }
      &:hover {
        background: #F5F5F5;
        /* background: #F5F5F5; */
      }
    }
  }

  /* #wrapper {
    width: 860px;
    margin: 0 auto;
    font-family: "Arial";
    li {
      margin-top: 20px;
    }
    a {
      font-size: 24px;
    }
    span {
      font-size: 24px;
    }
  } */

}
</style>



// WEBPACK FOOTER //
// component.vue?ff55e712